import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpg';
import './NotFound.css';

const NotFound: React.FC = () => (
  <div className="notfound-container">
    <img src={logo} alt="Club Participa" className="notfound-logo" />

    <h1 className="notfound-title">¡Vaya! Parece que te has perdido</h1>
    <p className="notfound-text">La página que buscas no existe o ha cambiado de dirección.</p>
    <Link to="/" className="notfound-link">Volver al inicio</Link>
  </div>
);

export default NotFound;
